import { firebaseUrl } from '@/firebase/cloudFunctions';
import { async } from '@firebase/util';
import Stripe from 'stripe';

export const getStripeCheckout = async (
  customerId: string,
  productId: string,
  quantity: number = 1
): Promise<Stripe.Checkout.Session | undefined> => {
  try {
    const result = await fetch(firebaseUrl + 'getStripeCheckout', {
      method: 'POST',
      body: JSON.stringify({
        customerId: customerId,
        productId: productId,
        quantity: quantity
      })
    });
    if (!result.ok) {
      console.error(`Failed to get stripe checkout`);
      return undefined;
    }
    return await result.json();
  } catch (error) {
    console.error(`Failed to get stripe checkout: ${error}`);
    return undefined;
  }
};

export const getStripeCustomerPortal = async (
  customerId: string
): Promise<Stripe.BillingPortal.Session | undefined> => {
  try {
    const result = await fetch(firebaseUrl + 'getStripeCustomerPortal', {
      method: 'POST',
      body: JSON.stringify({
        customerId: customerId
      })
    });
    if (!result.ok) {
      console.error(`Failed to get customer portal`);
      return undefined;
    }
    return await result.json();
  } catch (error) {
    console.error(`Failed to get customer portal: ${error}`);
    return undefined;
  }
};

export const getStripeCustomerSubscription = async (
  customerId: string
): Promise<Stripe.Subscription | undefined> => {
  try {
    const result = await fetch(firebaseUrl + 'getStripeCustomerSubscription', {
      method: 'POST',
      body: JSON.stringify({
        customerId: customerId
      })
    });
    if (!result.ok) {
      console.error(`Failed to get customer subscription`);
      return undefined;
    }
    return await result.json();
  } catch (error) {
    console.error(`Failed to get customer subscription: ${error}`);
    return undefined;
  }
};

export const getSubscriptionQuantity = (subscription: Stripe.Subscription) => {
  return subscription.items.data[0].quantity || 1;
};

export const getSubscriptionPrice = (subscription: Stripe.Subscription) => {
  if (
    subscription.items.data[0].price &&
    subscription.items.data[0].price.unit_amount
  )
    return (
      (subscription.items.data[0].price.unit_amount *
        getSubscriptionQuantity(subscription)) /
      100
    );
  if (subscription.items.data[0].plan.amount)
    return (
      (subscription.items.data[0].plan.amount *
        getSubscriptionQuantity(subscription)) /
      100
    );
};
